import assert from './assert';

export default (value1, value2) =>
  assert(value1 === value2, `Value '${value1}' must equal value '${value2}'.`);
